import React, { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";

const CONSENT_KEY = "bygglovkollen_cookies_v1";

/**
 * GDPR-cookies-banner. Visas endast om användaren inte har valt ännu.
 * Sparar valet i localStorage så att bannern inte återkommer.
 */
export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) {
      setShow(true);
    }
  }, []);

  const save = (level) => {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({ level, at: new Date().toISOString() }));
    setShow(false);
    if (level === "all") {
      // Framtida: aktivera analytics/pixel här
      window.dispatchEvent(new CustomEvent("cookieconsent:allow-analytics"));
    }
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-6 md:left-auto md:right-6 md:max-w-md z-50" data-testid="cookie-consent">
      <div className="bg-zinc-900 text-white border border-zinc-700 rounded-sm p-5 shadow-2xl">
        <div className="flex items-start gap-3 mb-3">
          <Cookie className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <h3 className="font-semibold text-sm mb-1" style={{ fontFamily: "Outfit" }}>Vi använder cookies</h3>
            <p className="text-xs text-zinc-300 leading-relaxed">
              Nödvändiga cookies för inloggning är alltid aktiva. Övriga cookies (statistik) hjälper oss förbättra tjänsten.
              <a href="/privacy" className="text-blue-400 hover:underline ml-1">Läs mer</a>
            </p>
          </div>
          <button onClick={() => save("necessary")} aria-label="Stäng" className="p-1 hover:bg-zinc-800 rounded-sm">
            <X className="w-4 h-4 text-zinc-400" />
          </button>
        </div>
        <div className="flex gap-2 mt-4">
          <button
            onClick={() => save("necessary")}
            data-testid="cookie-necessary"
            className="flex-1 px-3 py-2 text-xs border border-zinc-600 hover:bg-zinc-800 rounded-sm font-medium"
          >
            Endast nödvändiga
          </button>
          <button
            onClick={() => save("all")}
            data-testid="cookie-all"
            className="flex-1 px-3 py-2 text-xs bg-blue-700 hover:bg-blue-600 rounded-sm font-medium"
          >
            Tillåt alla
          </button>
        </div>
      </div>
    </div>
  );
}
